module.exports = __webpack_public_path__ + "img/3.b713a2f9.jpg";